export default __webpack_public_path__ + "static/media/working-at-cool.79077da3.jpg";